import api from '@/api/services/achievements';
import { commanderQueryKey } from '@/components/CommandCenter/LeftBox/ArmiesSection/ArmiseList';
import { ITaskCategoryData } from '@/types/Achievements';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styles from './CampaignCards.module.scss';
import BadgeTabs from './components/BadgesAchievements/BadgeTabs';

type CatTitle = 'All' | 'Social' | 'Referral' | 'Profile' | 'NFT & Staking' | 'Game' | 'Live' | 'Me';

const CampaignCards = () => {
  const router = useRouter();
  const [queries, setQueries] = useState<{
    commander_id?: string;
    category_ids?: string[];
    sort?: 'ASC' | 'DSC';
    filter?: string;
    role: null | 'true';
  }>({
    category_ids: [],
    filter: null,
    sort: null,
    role: null,
    commander_id: null,
  });

  const { category } = router.query;
  const filteredCatQuery = typeof category === 'string' ? category : null;
  const [activeCategory, setActiveCategory] = useState<string>(filteredCatQuery || 'All');
  const [allCategories, setAllCategories] = useState([]);
  const [allRankCategories, setAllRankCategories] = useState([]);
  const { data: categories, isLoading: isCategoryLoading } = api.useTaskCategories({ ...queries });
  const [gameId, setGameId] = useState('');

  const [initRankCat, setInitRankCat] = useState<
    {
      categories: ITaskCategoryData[];
      type: string;
    }[]
  >([]);

  useEffect(() => {
    let myRankCategory = categories?.data?.data?.categories?.filter((item) => item.type === 'rank') || [];
    if (myRankCategory.length > 0) {
      setInitRankCat(myRankCategory);
    }
  }, [categories?.data?.data?.categories]);

  let mainCategory = categories?.data?.data?.categories?.filter((item) => item.type === 'main') || [];
  // let rankCategory = categories?.data?.data?.categories?.filter((item) => item.type === 'rank') || [];

  // CommanderQuery
  const { [commanderQueryKey]: commanderQuery } = router.query;
  const filteredCommanderQuery = typeof commanderQuery === 'string' ? commanderQuery : null;

  useEffect(() => {
    setGameId(mainCategory[0]?.categories.find((item) => item.category_name === 'Game').id);
  }, [mainCategory]);

  useEffect(() => {
    if (filteredCommanderQuery !== null) {
      setQueries((prevQueries: any) => ({
        ...prevQueries,
        role: null,
        commander_id: filteredCommanderQuery,
      }));
    } else {
      if (queries.commander_id !== null) {
        setQueries((prevQueries: any) => ({
          ...prevQueries,
          role: null,
          commander_id: null,
        }));
      }
    }
  }, [filteredCommanderQuery]);

  useEffect(() => {
    if (category && typeof category === 'string') {
      setActiveCategory(category as CatTitle);
    }
  }, [category]);

  // Update queries.category_ids when activeCategory changes
  useEffect(() => {
    if (categories?.data?.data?.categories) {
      // Combine main and rank categories
      const allCategoriesList = [...(mainCategory[0]?.categories || []), ...(initRankCat[0]?.categories || [])];

      // Find the selected category
      const selectedCategory = allCategoriesList.find((cat) => cat.category_name === activeCategory);

      // Get the category ID
      const categoryId = activeCategory !== 'All' && selectedCategory ? selectedCategory.id : null;

      // Update the queries state
      setQueries((prevQueries) => ({
        ...prevQueries,
        category_ids: categoryId ? [categoryId] : [],
      }));
    }
  }, [activeCategory, categories]);

  const handleCategoryChange = (cat: ITaskCategoryData) => {
    setActiveCategory(cat?.category_name);
    router.replace(
      {
        pathname: router.pathname,
        query: { ...router.query, category: cat?.category_name },
      },
      undefined,
      { shallow: true },
    );
  };

  let allCat: ITaskCategoryData = {
    category_name: 'All',
    color: '#FFFFFF',
    index: 10,
    icon: '/images/tasks/note-2.png',
    achievement_count: categories?.data?.data?.total || 0,
    type: 'main',
    id: 'all',
  };

  useEffect(() => {
    if (mainCategory !== undefined) {
      setAllCategories([allCat].concat(mainCategory[0]?.categories || []));
    }
  }, [categories?.data?.data?.categories]);

  useEffect(() => {
    if (initRankCat !== undefined) {
      // Sort rank categories based on index
      setAllRankCategories(initRankCat[0]?.categories || []);
    }
  }, [initRankCat]);

  return (
    <div className={styles.container}>
      <BadgeTabs
        queries={queries}
        categories={allRankCategories}
        setActiveCategory={setActiveCategory}
        activeCategory={activeCategory}
        setQueries={setQueries}
        onCategoryChange={handleCategoryChange}
        filteredCommanderQuery={filteredCommanderQuery}
        gameId={gameId}
      />
    </div>
  );
};

export default CampaignCards;
